import { BaseComunicationProvider } from './basecomunication';
import { Injectable } from '@angular/core';
import { LoginResult } from '../entities/loginResult';
import { CurrentUser } from '../entities/currentUser';
import { LastLogin } from '../entities/lastLogin';

@Injectable()
export class LoginService  extends BaseComunicationProvider {
    public address: string = "LoginHandler.ashx"; 

    login(userName: string, password: string, savePassword: boolean) {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("SignUp", JSON.stringify({ 
                UserName: userName,
                Password: password
             }))
              .then(data => {
                var json: any = data;
                var currentUser: CurrentUser = {
                    Token: json.Item.SessionToken,
                    User: json.Item.Item
                }
                var loginResult = new LoginResult();
                loginResult.Message = json.Item.Message;
                loginResult.Success = json.Item.Success;
                var lastLogin: LastLogin;
                if (savePassword) {
                    lastLogin = {
                        AutoLogin: true,
                        UserName: userName,
                        Password: password
                    }
                }
                else {
                    lastLogin = {
                        AutoLogin: false,
                        UserName: userName,
                        Password: ""
                    }
                }
                this.localStorage.setItem("lastLogin", JSON.stringify(lastLogin));
                this.localStorage.setItem("user", JSON.stringify(currentUser));
                resolve(loginResult);
              }).catch((err) => {
                  reject(err);
              });
            })
        };

        create(userName: string, email: string, password: string) {
            return new Promise((resolve, reject) => {
                this.sendDataHttp("Create", JSON.stringify({ 
                    UserName: userName,
                    Password: password,
                    Email: email
                 }))
                  .then(data => {
                    resolve();
                  }).catch((err) => {
                      reject(err);
                  });
                })
        };

        passwordRecoveryStarteate(email: string) {
            return new Promise((resolve, reject) => {
                this.sendDataHttp("PasswordRecoveryStart", JSON.stringify({ 
                        Value: email
                    }))
                    .then(data => {
                    resolve();
                    }).catch((err) => {
                        reject(err);
                    });
            })
        };

        changePasswordByCode(email: string, code: string, password: string) {
            return new Promise((resolve, reject) => {
                this.sendDataHttp("ChangePasswordByCode", JSON.stringify({ 
                        Email: email,
                        Code: code,
                        Password: password
                    }))
                    .then(data => {
                    resolve();
                    }).catch((err) => {
                        reject(err);
                    });
            })
        };
}


// WEBPACK FOOTER //
// ./src/providers/login.ts